import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import authentication from './util/authentication'
import axios from "axios"

import VueSlideoutPanel from 'vue2-slideout-panel';

Vue.use(VueSlideoutPanel);

import MessageList from "./components/Messages/Messages.vue";
Vue.component('message-list', MessageList)

import Message from "./components/Messages/Message.vue";
Vue.component('message-viewer', Message)

import AssignToClaim from "./components/Messages/AssignToClaim.vue";
Vue.component('assign-to-claim', AssignToClaim)

import MessageCompose from "./components/Messages/Compose.vue";
Vue.component('message-compose', MessageCompose)

import MessageComposeTemplates from "./components/Messages/ComposeTemplates.vue";
Vue.component('message-compose-templates', MessageComposeTemplates)

import MessageTag from "./components/Messages/Tag.vue";
Vue.component('message-tag', MessageTag)

import ClaimMessages from '@/components/ClaimMessages.vue'
Vue.component('claim-messages', ClaimMessages)

import PageHeader from '@/components/PageHeader.vue'
Vue.component('page-header', PageHeader)

import DataListPagination from '@/components/DataListPagination.vue'
Vue.component('data-list-pagination', DataListPagination)

import RequestMoreDocs from '@/components/RequestMoreDocs.vue'
Vue.component('request-more-docs', RequestMoreDocs)

import ClaimDocumentTabs from '@/components/ClaimDocumentTabs.vue'
Vue.component('claim-document-tabs', ClaimDocumentTabs)

import DataListCSV from '@/components/DataListCSV.vue'
Vue.component('data-list-csv', DataListCSV)

let isRefreshing = false

import VueSanitize from "vue-sanitize";
Vue.use(VueSanitize);

axios.interceptors.response.use(null, err => {

    if (err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest) {
        err.response.config.__isRetryRequest = true;

        return new Promise((resolve, reject) => {
            authentication.acquireToken()
                .then(token => { 
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    err.config.headers.Authorization = `Bearer ${token}`;

                    axios(err.config).then(resolve, reject);
            });
        });
    }
    throw err;
});


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading)

import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/site.css'
import '@/assets/site.scss'

import wysiwyg from "vue-wysiwyg";
let wysiwgConfig = {
    hideModules: {
        "justifyLeft": true,
        "justifyCenter": true,
        "justifyRight": true,
        "link": true,
        "code": true,
        "image": true,
        "table": true,
        "separator": true,
        "headings": true
    },
}

Vue.use(wysiwyg, wysiwgConfig); // config is optional. more below

import "vue-wysiwyg/dist/vueWysiwyg.css";

store.subscribe((muation, state) => {
    localStorage.setItem('store', JSON.stringify(state))
})



// Global route guard
router.beforeEach((to, from, next) => {

    // all the app is auth only...

    //if (to.matched.some(record => record.meta.requiresAuthentication)) {
        // this route requires auth, check if logged in
        if (authentication.isAuthenticated()) {
            // only proceed if authenticated.
            next();
        } else {
            authentication.signIn();
        }
    //} else {
    //    next();
    //}
});

Vue.prototype.$hashCode = function (val) {
    val = val.toString()
    var hash = 0, i, chr;
    if (val.length === 0) return hash;
    for (i = 0; i < val.length; i++) {
        chr = val.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

// Init adal authentication - then create Vue app.
authentication.initialize().then(_ => {
    /* eslint-disable no-new */
    new Vue({
        router,
        components: {

        },
        store,
        render: h => h(App)
    }).$mount('#app')
});

